import styled from 'styled-components';

export const SwitcherWrapper = styled.div`
  display: flex;
  .MuiFormControlLabel-root {
    justify-content: space-between;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    flex-direction: row-reverse;
  }
  .MuiTypography-root {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.43;
    color: #1b1b1b;
  }
`;
